import React from 'react'
import { makeStyles, useMediaQuery, useTheme } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import Button from '../components/button/Button'
import StyledSVG from '../components/shared/StyledSVG'
import configGearIcon from '../assets/icons/config-gear-icon.svg'
import SearchPickupAuthorizationsForm from '../components/form/SearchPickupAuthorizationsForm'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '32px',
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('600')]: {
      padding: 16
    }
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('600')]: {
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center'
    }
  },
  title_section: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 24,
    '& p.description': {
      margin: 0,
      fontSize: 16,
      fontWeight: 400
    },
    [theme.breakpoints.down('600')]: {
      rowGap: 5,
      paddingBottom: 16
    }
  },
  title: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    '& p': {
      color: '#386093',
      margin: 0,
      fontWeight: 700,
      fontSize: 32
    },
    '& svg': {
      '& path': {
        stroke: '#386093'
      }
    }
  },
  btn_wrapper: {
    width: 144,
    height: 48
  },
  button_root: {
    width: '100%',
    height: '100%'
  },
  go_back_btn: {
    backgroundColor: '#F4A87C',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#F4A87C'
    },
    fontSize: '16px',
    fontWeight: 700,
    textTransform: 'capitalize',
    lineHeight: '100%',
    height: '100%',
    width: '100%'
  },
  filter_section: {
    gridColumn: 'span 8'
  },
  filter_section_first_row: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: 32
  },
  search_component: {
    width: '100%',
    height: 40,
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1px solid #D2D5D8',
    '& input': {
      padding: 0
    }
  },
  input: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '60%',
    '& p.label': {
      margin: 0,
      fontSize: 12,
      fontWeight: 600
    }
  },
  create_btn: {
    backgroundColor: '#00ACDB',
    height: 48,
    padding: '12px 48px',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#00ACDB'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    lineHeight: '19.5px',
    '& .label_wrapper': {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      '& p': {
        margin: 0
      }
    }
  }
}))

const PickupAuthorizationsPage = ({ handleSubmit, onSubmit }) => {
  const classes = useStyles()
  const history = useHistory()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('850'))
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.title_section}>
          <div className={classes.title}>
            {matches && (
              <StyledSVG src={configGearIcon} width={32} height={32} />
            )}
            <p>Gerenciar autorizações</p>
          </div>
          <p className='description'>
            Visualize, edite e crie autorizações para retirada de alunos.
          </p>
        </div>
        <div className={classes.btn_wrapper}>
          <Button
            type='button'
            onclick={() => history.push('/pickup')}
            rootClass={classes.button_root}
            className={classes.go_back_btn}
          >
            Voltar
          </Button>
        </div>
      </div>
      <SearchPickupAuthorizationsForm />
    </div>
  )
}

export default PickupAuthorizationsPage
